// extracted by mini-css-extract-plugin
module.exports = {"richtext":"rich-text_richtext__UwmsZ"};